<template>
    <div class="logo-slider" :style="cssVars" v-if="logos">
        <div v-for="(logo, i) in logos" :key="i">
            <img :src="baseURL + logo.url"  contain/>
        </div>
        <div v-for="(logo, i) in logos" :key="i + logos.length">
            <img :src="baseURL + logo.url"  contain/>
        </div>
    </div>
</template>

<script>
  import SiteService from "../services/site.service";
  import {flattenObj} from "@/utils/utils";
  export default {
    name: 'ContinuousCarousel',
    props: ['pageName'],
    data() {
        return {
            logos: [],
            baseURL: process.env.VUE_APP_CMS_BASE_URL ?? 'https://dev.cms.edurent.com',
            animationSpeed: 15,
            logoCount: 5
        }
    },
     computed: {
        cssVars () {
            return {
            /* variables you want to pass to css */
            '--speed': this.animationSpeed + 's',
            '--count': this.logoCount
            }
        }
    },
    async beforeMount() {
        const response = await SiteService.getLogos();
        let collection = flattenObj(response)

        this.logos = collection[0]["images"];
        this.logoCount = this.logos.length <= 5 ? 10 : this.logos.length ;
        this.animationSpeed = 10 + (3 * this.logoCount);
    }
  }
</script>
<style scoped lang="scss">
.logo-slider {
    $min-image-size: 30px;
    $max-image-size: 30px;
    --image-size: #{$max-image-size};
    padding: 20px;
    overflow: hidden;
    width: 100vw !important;
    height: 4rem;
    margin: 0 auto;
    position: relative;
    display: flex;
    background-color: black;
    div {
        animation: marquee var(--speed) linear infinite;
        -webkit-animation: marquee-ios var(--speed) linear infinite;
    }

    &:hover div {
        animation-play-state: paused;
    }

    div {
        display: flex;
        position: relative;
        justify-content: space-around;
    }

    img {
        display: block;
        min-width: var(--image-size);
        height: var(--image-size);
        margin: 0 1vw;
        @media (max-width:991px) {
            margin: 0 2vw;
        }
    }

    &:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }

    @media (max-width:900px) {
        --image-size: #{$min-image-size};
        --image-size: min(max(#{$min-image-size}, 10vw), #{$max-image-size});
    }

}

@keyframes marquee {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(calc(-250px * (var(--count) - 10)))
    }
}

@-webkit-keyframes marquee-ios {
    0% {
        -webkit-transform: translateX(0);
    }

    100% {
        -webkit-transform: translateX(calc(-250px * (var(--count) - 10)))
    }
}

</style>
